import { render } from "./Interests.vue?vue&type=template&id=ff2928dc&ts=true"
import script from "./Interests.vue?vue&type=script&lang=ts"
export * from "./Interests.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__